// extracted by mini-css-extract-plugin
export default {"genericCard":"kp-z","inline":"lp-z","mastercard":"mp-z","discover":"np-z","visa":"op-z","amex":"pp-z","active":"qp-z"};